// import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './DistributorsPage.module.scss';
import PropTypes from 'prop-types';

//Components
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Hero from '../../components/Hero';
import DistributorCardList from '../../components/DistributorCardList/DistributorCardList';

const DistributorsPage = ({ settings = {
        hero: {},
        footer: {},
    }, hero, items }) => {
    return (
        <div className={styles['DistributorsPage']}>
            <Header {...settings.header} />
            <main>
                {hero && <Hero {...hero} />}
                <div className={styles['DistributorsPage__Container']}>
                    {items && <DistributorCardList items={items} />}
                </div>
            </main>
            <Footer {...settings.footer} />
        </div>
    );
};

DistributorsPage.propTypes = {
    hero: PropTypes.object,
    footer: PropTypes.object,
};

export default basePageWrap(DistributorsPage);
